
import styled, { css } from 'styled-components';
import breakpoint, { map } from 'styled-components-breakpoint';


export const Card = styled.div`
    display: flex; 
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 3px;
    padding: 2rem 0;
    box-shadow: 0 .5rem .5rem rgba(0,0,0, .11);
    position: relative;
    padding: 3rem 4rem;
    padding-top: 0;

    &::before{
        content: "</>"; 
        font-size: 5rem;
        position: absolute;
        top: -2.75rem;
        right: 0rem;  
        color: rgba(119, 119, 119, 0.11);
        font-family: sans-serif;
        line-height: 1 ;

        z-index: 1;
        ${breakpoint('xs','md')`  
        font-size: 5rem;



    `}
    }

`


export const Wrapper = styled.div`

    flex:1;
    display:flex;
    // align-self: flex-end;
    align-items: center;
    margin-bottom: 1rem;
`

export const Pic = styled.img`    
    height:5rem;
    width:5rem;
    border-radius: 50%;
    margin-right: 1.5rem;
`

export const Name = styled.p`
    font-weight: 900
`

export const PLink = styled.a`
    &,
    &:link,
    &:visited{
        // margin: 1rem 0
        margin-top: 1rem;
        align-self: flex-end;
        padding: 1rem 2rem;
        border-radius: 10000px; 
        color: #fff;
        font-size: 1.3rem;
        background-image: linear-gradient(to right bottom,#606c88, #3f4c6b);
        // box-shadow: 0 1.5rem 4rem rgba(0, 0, 0, 0.5);
        text-decoration: none;
        cursor: pointer;
        transition: all .3s;


    }

    &:hover{
        transform: translateY(-.5rem);
    }
   
    &:active{
        transform: translateY(0rem);
        
    }

`